import { backofficeFetch } from '@/services/backoffice-api';
import type { BackofficeTag } from './types';
import type { TagColor } from '@/components/shared/tag-colors';

export async function fetchBackofficeTags(signal?: AbortSignal): Promise<BackofficeTag[]> {
  const response = await backofficeFetch('/tags', signal ? { signal } : {});
  if (!response.ok) {
    throw new Error('Failed to load tags');
  }

  const payload = (await response.json()) as { items?: BackofficeTag[] };
  return payload.items ?? [];
}

export async function createBackofficeTag(input: {
  name: string;
  description?: string;
  color?: TagColor;
}): Promise<void> {
  const response = await backofficeFetch('/tags', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    throw new Error('Failed to create tag');
  }
}

export async function updateBackofficeTag(
  tagId: string,
  input: {
    name?: string;
    description?: string | null;
    color?: TagColor;
    status?: BackofficeTag['status'];
  }
): Promise<void> {
  const response = await backofficeFetch(`/tags/${tagId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    throw new Error('Failed to update tag');
  }
}
